<div class="side-panel-container">
  <ng-container *ngTemplateOutlet="template"></ng-container>
</div>